import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { client } from "../../api/client"

const apiURL = process.env.REACT_APP_GENESYS_API_URL
const usersApiURL = process.env.REACT_APP_STATIC_LISTS_API_URL

const initialState = {
    users: [],
    qs: [],
    wrapUpCodes: [],
    searchFields: {
        search: '',
        fromDate: '',
        fromTime: '',
        toDate: '',
        toTime: '',
        conversationId: '',
        contact: '',
        direction: '',
        user: '',
        q: '',
        wrapUpCodes: [],
        commaSeparatedWrapUpCodes: ''
    },
    status: 'idle',
    error: null,
}

export const fetchWrapUpCodes = createAsyncThunk('filters/fetchWrapUpCodes', async () => {
    if (usersApiURL) {
        return [];
    } else {
        const response = await client.get(apiURL, '/Stage?entitytype=WrapupCode');
        console.log('fetchWrapUpCodes', response.data);
        return response.data;
    }
});

export const fetchUsers = createAsyncThunk('filter/fetchUsers', async () => {
    if (usersApiURL) {
        const response = await client.get(usersApiURL, '/users')
        console.log('fetchUsers', response.data)

        return response.data;

        // const testUser =
        // {
        //   "id": "220",
        //   "username": "TC Reception",
        //   "name": "Tims House Reception"
        // }

        // const data = response.data;

        // const mdata = [...data, testUser];

        // return mdata

    } else {
        const response = await client.get(apiURL, '/Stage?entitytype=User')
        console.log('fetchUsers', response.data)
        return response.data
    }
})

export const fetchQs = createAsyncThunk('filter/fetchQs', async () => {
    if (process.env.REACT_APP_DISABLE_QUEUES === 'true') {
        console.log('fetchQs disabled by environment variable')
        return [] // return empty array when disabled
    }
    const response = await client.get(apiURL, '/Stage?entitytype=Queue')
    console.log('fetchQs', response.data)
    return response.data
})

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setSearchFields(state, action) {
            state.searchFields = action.payload;
        },
        clearSearchFields(state) {
            state.searchFields = initialState.searchFields;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchUsers.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.status = 'succeeded'
                // Add any fetched users to the array
                state.users = action.payload
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
            .addCase(fetchQs.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchQs.fulfilled, (state, action) => {
                state.status = 'succeeded'
                // Add any fetched qs to the array
                state.qs = action.payload
            })
            .addCase(fetchQs.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
            .addCase(fetchWrapUpCodes.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchWrapUpCodes.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.wrapUpCodes = action.payload
            })
            .addCase(fetchWrapUpCodes.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
    }
})

export const { setSearchFields, clearSearchFields } = filterSlice.actions

export default filterSlice.reducer

export const selectAllUsers = (state) => state.filter.users;
export const selectAllQs = (state) => state.filter.qs;
export const selectSearchFields = (state) => state.filter.searchFields;
export const selectWrapUpCodes = (state) => state.filter.wrapUpCodes;